<template>
    <vx-box color="info" class="flex flex-col px-8 py-20 gap-6 items-center justify-center text-xl text-slate-700 h-80">
        <font-awesome-icon widthAuto size="xl" :icon="faMessages"></font-awesome-icon>
        <span class="font-bold text-base">
            {{ pluralized('Scheduled Messages', scheduledMessagesCount, scheduledMessagesCount) }}
        </span>
    </vx-box>
</template>

<script setup>
import { faMessages } from '@fortawesome/pro-solid-svg-icons';
import { VxBox } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { useScheduledMessages } from '~/components/message-hub/useScheduledMessages';
import { pluralized } from '~/components/filters';
import { useCurrentGroup } from '~/composables/useCurrentGroup';

const teamId = Spark.state.currentTeam.id;
const { getCurrentGroupId } = useCurrentGroup();
const { fetchScheduledMessagesCount, scheduledMessagesCount } = useScheduledMessages();

fetchScheduledMessagesCount({ teamId, groupId: getCurrentGroupId() });
</script>
